var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182398",
    "data-name": "Group 182398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149783",
    "data-name": "Rectangle 149783",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload_725008",
    transform: "translate(5 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182385",
    "data-name": "Group 182385",
    transform: "translate(3.419 3.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182384",
    "data-name": "Group 182384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49751",
    "data-name": "Path 49751",
    d: "M135.927,4.2,132.4.172a.5.5,0,0,0-.757,0L128.123,4.2a.5.5,0,0,0,.379.835h2.014v6.544a.5.5,0,0,0,.5.5h2.014a.5.5,0,0,0,.5-.5V5.034h2.014a.5.5,0,0,0,.379-.835Z",
    transform: "translate(-127.998)",
    fill: "#4169E1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182387",
    "data-name": "Group 182387",
    transform: "translate(0 14.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182386",
    "data-name": "Group 182386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49752",
    "data-name": "Path 49752",
    d: "M28.907,352v3.021H17.986V352H16v4.027a1,1,0,0,0,.993,1.007H29.9a1,1,0,0,0,.993-1.007V352Z",
    transform: "translate(-16 -352)",
    fill: "#4169E1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.594622d59c8100e35064b9d510235a80.svg";
export { ForwardRef as ReactComponent };